import { render, staticRenderFns } from "./ChooseChildren.vue?vue&type=template&id=d12d91a8&scoped=true&"
import script from "./ChooseChildren.vue?vue&type=script&lang=js&"
export * from "./ChooseChildren.vue?vue&type=script&lang=js&"
import style0 from "./ChooseChildren.vue?vue&type=style&index=0&id=d12d91a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12d91a8",
  null
  
)

export default component.exports